// Centralized FAQ content (Indonesian). Complete, no placeholders.

export const HOME_FAQ = [
  {
    q: "Bagaimana cara memesan?",
    a: "Buka Katalog Produk, pilih platform dan durasi, lalu tekan Pesan via WhatsApp. Detail produk, harga, dan kode variant akan dimasukkan secara otomatis ke dalam pesan.",
  },
  {
    q: "Bagaimana mengetahui produk tersedia?",
    a: "Ketersediaan ditampilkan pada pilihan paket. Karena stok produk digital dapat berubah, konfirmasi terakhir dilakukan saat pemesanan melalui WhatsApp.",
  },
  {
    q: "Mengapa harga setiap durasi berbeda?",
    a: "Harga mengikuti produk dan masa aktif yang dipilih. Pastikan harga yang tercantum pada ringkasan paket dan pesan WhatsApp sudah sesuai sebelum melanjutkan.",
  },
  {
    q: "Apakah pesanan dapat dibatalkan atau direfund?",
    a: "Produk digital yang sudah berhasil diaktifkan tidak dapat dibatalkan atau direfund.",
  },
  {
    q: "Apakah saya perlu membuat akun Nofina Movie?",
    a: "Tidak. Kamu dapat memilih produk melalui katalog dan melanjutkan pemesanan langsung melalui WhatsApp.",
  },
];

export const BANTUAN_FAQ = [
  {
    q: "Bagaimana cara memesan?",
    a: "Buka Katalog Produk, pilih platform dan durasi, lalu tekan Pesan via WhatsApp. Detail produk, harga, dan kode variant akan dimasukkan secara otomatis ke dalam pesan.",
  },
  {
    q: "Bagaimana mengetahui produk tersedia?",
    a: "Ketersediaan ditampilkan pada pilihan paket. Karena stok produk digital dapat berubah, konfirmasi terakhir dilakukan saat pemesanan melalui WhatsApp.",
  },
  {
    q: "Mengapa harga setiap durasi berbeda?",
    a: "Harga mengikuti produk dan masa aktif yang dipilih. Pastikan harga yang tercantum pada ringkasan paket dan pesan WhatsApp sudah sesuai sebelum melanjutkan.",
  },
  {
    q: "Apakah akun boleh digunakan di beberapa perangkat?",
    a: "Tidak. Akun maksimal digunakan pada satu perangkat, kecuali informasi produk menyatakan ketentuan yang berbeda.",
  },
  {
    q: "Apakah akun boleh dibagikan?",
    a: "Tidak. Akun private tidak boleh dibagikan atau dipindahtangankan kepada pihak lain.",
  },
  {
    q: "Apakah pesanan dapat dibatalkan atau direfund?",
    a: "Produk digital yang sudah berhasil diaktifkan tidak dapat dibatalkan atau direfund.",
  },
  {
    q: "Berapa lama masa garansi?",
    a: "Garansi berlaku tujuh hari sejak aktivasi berhasil dan hanya mencakup kendala teknis yang berasal dari layanan atau akun yang diberikan oleh Nofina Movie.",
  },
  {
    q: "Bagaimana cara mengajukan bantuan atau garansi?",
    a: "Hubungi Nofina Movie melalui WhatsApp dan sertakan nama produk, kode produk, detail kendala, serta bukti pendukung yang relevan.",
  },
  {
    q: "Mengapa akun dapat kehilangan garansi?",
    a: "Garansi dapat batal apabila akun dibagikan, digunakan pada lebih dari satu perangkat, data akun diubah tanpa instruksi, disalahgunakan, atau digunakan dengan cara yang melanggar ketentuan.",
  },
  {
    q: "Apakah saya perlu membuat akun Nofina Movie?",
    a: "Tidak. Kamu dapat memilih produk melalui katalog dan melanjutkan pemesanan langsung melalui WhatsApp.",
  },
];
